import request from '@/utils/request'

// 学生认证审核列表
export function getVerifyList(params) {
  return request({
    url: '/admin/user/verify/list',
    method: 'get',
    params
  })
}

// 认证审核：通过 / 驳回
export function reviewVerify(data) {
  return request({
    url: '/admin/user/verify/review',
    method: 'post',
    data
  })
}
